import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonSpinner,
  IonToolbar,
} from '@ionic/react'

import { useAccount } from '../../../contexts/authContext'
import { Card, CardContent, CardHeader } from '../../../components/ui/card'
import { useActiveStations } from '../../../check-in/paired/queries'

function PairedCheckInInfoPage() {
  const { user, groups } = useAccount()
  const { data: stations, isLoading } = useActiveStations()

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton color="secondary" />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <div className="mx-auto max-w-xl space-y-3">
          <Card>
            <CardHeader>User Info</CardHeader>
            <CardContent>
              {user.displayName ? (
                <p>
                  <span className="font-semibold">Display Name: </span>
                  {user.displayName}
                </p>
              ) : null}
              {user.firstName ? (
                <p>
                  <span className="font-semibold">First Name: </span>
                  {user.firstName}
                </p>
              ) : null}
              {user.lastName ? (
                <p>
                  <span className="font-semibold">Last Name: </span>
                  {user.lastName}
                </p>
              ) : null}
              {user.email ? (
                <p>
                  <span className="font-semibold">Email: </span>
                  {user.email}
                </p>
              ) : null}
            </CardContent>
          </Card>

          <Card>
            <CardHeader>Station Info</CardHeader>
            <CardContent>
              {stations ? (
                stations?.map((station) => (
                  <div key={`${station.objectId}`}>
                    {station.isClient ? (
                      <p>
                        <span className="font-semibold">
                          Customer Station:{' '}
                        </span>
                        {station.name}
                      </p>
                    ) : null}
                    {station.isPos ? (
                      <p>
                        <span className="font-semibold">Cashier Station: </span>
                        {station.name}
                      </p>
                    ) : null}
                  </div>
                ))
              ) : isLoading ? (
                <div className="flex justify-center">
                  <IonSpinner color="primary" name="dots" />
                </div>
              ) : null}
            </CardContent>
          </Card>

          <Card>
            <CardHeader>Account Info</CardHeader>
            <CardContent>
              {groups.map((group) => (
                <div key={`${group.groupId}-${group.role}`}>
                  <p>
                    <span className="font-semibold capitalize">
                      {group.role}
                    </span>{' '}
                    at <span className="font-semibold">{group.name}</span>
                  </p>
                </div>
              ))}
              {process.env.REACT_APP_VERSION ? (
                <p>
                  <span className="font-semibold">
                    App Version: {process.env.REACT_APP_VERSION}
                  </span>
                </p>
              ) : null}
            </CardContent>
          </Card>
        </div>
      </IonContent>
    </IonPage>
  )
}

export { PairedCheckInInfoPage }
